export const BOARD_SIZE = 8;

export function createBoard() {
  return Array.from({ length: BOARD_SIZE }, () =>
    Array.from({ length: BOARD_SIZE }, () => null)
  );
}

export function canPlace(board, piece, row, col) {
  const { shape } = piece;
  for (let r = 0; r < shape.length; r++) {
    for (let c = 0; c < shape[r].length; c++) {
      if (shape[r][c]) {
        const br = row + r;
        const bc = col + c;
        if (br < 0 || br >= BOARD_SIZE || bc < 0 || bc >= BOARD_SIZE) {
          return false;
        }
        if (board[br][bc] !== null) {
          return false;
        }
      }
    }
  }
  return true;
}

export function placePieceOnBoard(board, piece, row, col) {
  const newBoard = board.map((r) => [...r]);
  const { shape, color } = piece;
  for (let r = 0; r < shape.length; r++) {
    for (let c = 0; c < shape[r].length; c++) {
      if (shape[r][c]) {
        newBoard[row + r][col + c] = color;
      }
    }
  }
  return newBoard;
}

export function findCompletedLines(board) {
  const rows = [];
  const cols = [];

  for (let r = 0; r < BOARD_SIZE; r++) {
    if (board[r].every((cell) => cell !== null)) {
      rows.push(r);
    }
  }

  for (let c = 0; c < BOARD_SIZE; c++) {
    let full = true;
    for (let r = 0; r < BOARD_SIZE; r++) {
      if (board[r][c] === null) {
        full = false;
        break;
      }
    }
    if (full) cols.push(c);
  }

  return { rows, cols };
}

export function clearLines(board, { rows, cols }) {
  if (rows.length === 0 && cols.length === 0) return board;

  const newBoard = board.map((r) => [...r]);

  for (const r of rows) {
    for (let c = 0; c < BOARD_SIZE; c++) {
      newBoard[r][c] = null;
    }
  }

  for (const c of cols) {
    for (let r = 0; r < BOARD_SIZE; r++) {
      newBoard[r][c] = null;
    }
  }

  return newBoard;
}

export function getClearedCells(board, { rows, cols }) {
  const cells = [];
  const seen = new Set();

  for (const r of rows) {
    for (let c = 0; c < BOARD_SIZE; c++) {
      const key = `${r},${c}`;
      if (!seen.has(key) && board[r][c] !== null) {
        cells.push({ row: r, col: c, color: board[r][c] });
        seen.add(key);
      }
    }
  }

  for (const c of cols) {
    for (let r = 0; r < BOARD_SIZE; r++) {
      const key = `${r},${c}`;
      if (!seen.has(key) && board[r][c] !== null) {
        cells.push({ row: r, col: c, color: board[r][c] });
        seen.add(key);
      }
    }
  }

  return cells;
}

export function canPlaceAnyPiece(board, pieces) {
  for (const piece of pieces) {
    const maxRow = BOARD_SIZE - piece.shape.length;
    const maxCol = BOARD_SIZE - piece.shape[0].length;
    for (let r = 0; r <= maxRow; r++) {
      for (let c = 0; c <= maxCol; c++) {
        if (canPlace(board, piece, r, c)) {
          return true;
        }
      }
    }
  }
  return false;
}

export function countFilledCells(board) {
  let count = 0;
  for (let r = 0; r < BOARD_SIZE; r++) {
    for (let c = 0; c < BOARD_SIZE; c++) {
      if (board[r][c] !== null) count++;
    }
  }
  return count;
}

export function applyBomb(board, centerRow, centerCol) {
  const newBoard = board.map((r) => [...r]);
  for (let r = centerRow - 1; r <= centerRow + 1; r++) {
    for (let c = centerCol - 1; c <= centerCol + 1; c++) {
      if (r >= 0 && r < BOARD_SIZE && c >= 0 && c < BOARD_SIZE) {
        newBoard[r][c] = null;
      }
    }
  }
  return newBoard;
}
